import { render, staticRenderFns } from "./wechat-login.vue?vue&type=template&id=3fc1aa08&scoped=true"
import script from "./wechat-login.vue?vue&type=script&lang=js"
export * from "./wechat-login.vue?vue&type=script&lang=js"
import style0 from "./wechat-login.vue?vue&type=style&index=0&id=3fc1aa08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1aa08",
  null
  
)

export default component.exports